import { ClientNames, ClientUserTypeNames } from './clients'

type UserTypeSetup = {
  module: string
  subs: {
    name: string
    subs?: { name: string }[]
    exclude?: { name: string | null }[]
  }[]
  exclude: { name: string | null }[]
}

type ClientUserTypes = {
  client: ClientNames
  userTypes: {
    name: ClientUserTypeNames<ClientNames>
    setup: UserTypeSetup[]
  }[]
}

export const USER_TYPES: ClientUserTypes[] = [
  {
    client: 'oporto',
    userTypes: [
      {
        name: 'super_user',
        setup: [
          {
            module: '*',
            subs: [
              { name: 'transaction', subs: [{ name: 'download transaction' }] },
            ],
            exclude: [],
          },
        ],
      },
      {
        name: 'display_user',
        setup: [
          {
            module: 'member',
            subs: [{ name: 'lookup' }, { name: 'dashboard' }],
            exclude: [],
          },
          { module: 'merchant', subs: [{ name: 'lookup' }], exclude: [] },
          { module: 'reports', subs: [{ name: 'lookup' }], exclude: [] },
          { module: 'voucher', subs: [{ name: 'lookup' }], exclude: [] },
        ],
      },
      {
        name: 'report_user',
        setup: [{ module: 'reports', subs: [{ name: '*' }], exclude: [] }],
      },
    ],
  },
  {
    client: 'redrooster',
    userTypes: [
      {
        name: 'super_user',
        setup: [{ module: '*', subs: [{ name: '*' }], exclude: [] }],
      },
      {
        name: 'display_user',
        setup: [
          {
            module: 'member',
            subs: [{ name: 'lookup' }, { name: 'dashboard' }],
            exclude: [],
          },
          { module: 'merchant', subs: [{ name: 'lookup' }], exclude: [] },
          { module: 'reports', subs: [{ name: 'lookup' }], exclude: [] },
          { module: 'voucher', subs: [{ name: 'lookup' }], exclude: [] },
        ],
      },
      {
        name: 'report_user',
        setup: [{ module: 'reports', subs: [{ name: '*' }], exclude: [] }],
      },
    ],
  },
  {
    client: 'chickentreat',
    userTypes: [
      {
        name: 'super_user',
        setup: [{ module: '*', subs: [{ name: '*' }], exclude: [] }],
      },
      {
        name: 'display_user',
        setup: [
          {
            module: 'member',
            subs: [{ name: 'lookup' }, { name: 'dashboard' }],
            exclude: [],
          },
          { module: 'merchant', subs: [{ name: 'lookup' }], exclude: [] },
          { module: 'reports', subs: [{ name: 'lookup' }], exclude: [] },
          { module: 'voucher', subs: [{ name: 'lookup' }], exclude: [] },
        ],
      },
      {
        name: 'report_user',
        setup: [{ module: 'reports', subs: [{ name: '*' }], exclude: [] }],
      },
    ],
  },
  {
    client: 'columbuscoffee',
    userTypes: [
      {
        name: 'super_user',
        setup: [{ module: '*', subs: [{ name: '*' }], exclude: [] }],
      },
      {
        name: 'display_user',
        setup: [
          {
            module: 'member',
            subs: [{ name: 'lookup' }, { name: 'dashboard' }],
            exclude: [],
          },
          { module: 'merchant', subs: [{ name: 'lookup' }], exclude: [] },
          { module: 'reports', subs: [{ name: 'lookup' }], exclude: [] },
          { module: 'voucher', subs: [{ name: 'lookup' }], exclude: [] },
        ],
      },
      {
        name: 'report_user',
        setup: [{ module: 'reports', subs: [{ name: '*' }], exclude: [] }],
      },
    ],
  },
  {
    client: 'hampsta',
    userTypes: [
      {
        name: 'super_user',
        setup: [{ module: '*', subs: [{ name: '*' }], exclude: [] }],
      },
      {
        name: 'display_user',
        setup: [
          {
            module: 'member',
            subs: [{ name: 'lookup' }, { name: 'dashboard' }],
            exclude: [],
          },
          { module: 'merchant', subs: [{ name: 'lookup' }], exclude: [] },
          { module: 'reports', subs: [{ name: 'lookup' }], exclude: [] },
          {
            module: 'bulk transactions',
            subs: [{ name: 'lookup' }],
            exclude: [],
          },
          { module: 'files', subs: [{ name: 'lookup' }], exclude: [] },
        ],
      },
      {
        name: 'report_user',
        setup: [{ module: 'reports', subs: [{ name: '*' }], exclude: [] }],
      },
    ],
  },
  {
    client: 'generic',
    userTypes: [
      {
        name: 'super_user',
        setup: [{ module: '*', subs: [{ name: '*' }], exclude: [] }],
      },
      {
        name: 'display_user',
        setup: [
          {
            module: 'member',
            subs: [{ name: 'lookup' }, { name: 'dashboard' }],
            exclude: [],
          },
          { module: 'merchant', subs: [{ name: 'lookup' }], exclude: [] },
          { module: 'reports', subs: [{ name: 'lookup' }], exclude: [] },
          {
            module: 'bulk transactions',
            subs: [{ name: 'lookup' }],
            exclude: [],
          },
          { module: 'files', subs: [{ name: 'lookup' }], exclude: [] },
        ],
      },
      {
        name: 'report_user',
        setup: [{ module: 'reports', subs: [{ name: '*' }], exclude: [] }],
      },
    ],
  },
  {
    client: 'paperplus',
    userTypes: [
      {
        name: 'super_user',
        setup: [{ module: '*', subs: [{ name: '*' }], exclude: [] }],
      },
      {
        name: 'display_user',
        setup: [
          {
            module: 'member',
            subs: [{ name: 'lookup' }, { name: 'dashboard' }],
            exclude: [],
          },
          { module: 'merchant', subs: [{ name: 'lookup' }], exclude: [] },
          { module: 'reports', subs: [{ name: 'lookup' }], exclude: [] },
          { module: 'voucher', subs: [{ name: 'lookup' }], exclude: [] },
        ],
      },
      {
        name: 'report_user',
        setup: [{ module: 'reports', subs: [{ name: '*' }], exclude: [] }],
      },
    ],
  },
  {
    client: 'countdown',
    userTypes: [
      {
        name: 'super_user',
        setup: [{ module: '*', subs: [{ name: '*' }], exclude: [] }],
      },
      {
        name: 'display_user',
        setup: [
          {
            module: 'member',
            subs: [{ name: 'lookup' }, { name: 'dashboard' }],
            exclude: [],
          },
          { module: 'merchant', subs: [{ name: 'lookup' }], exclude: [] },
          { module: 'reports', subs: [{ name: 'lookup' }], exclude: [] },
          { module: 'files', subs: [{ name: 'lookup' }], exclude: [] },
        ],
      },
      {
        name: 'report_user',
        setup: [{ module: 'reports', subs: [{ name: '*' }], exclude: [] }],
      },
    ],
  },
  {
    client: 'westfield',
    userTypes: [
      {
        name: 'super_user',
        setup: [
          {
            module: '*',
            subs: [{ name: '*', subs: [{ name: '*' }] }],
            exclude: [],
          },
        ],
      },
      {
        name: 'display_user',
        setup: [
          {
            module: 'member',
            subs: [{ name: 'lookup' }, { name: 'dashboard' }],
            exclude: [],
          },
          { module: 'merchant', subs: [{ name: 'lookup' }], exclude: [] },
          { module: 'reports', subs: [{ name: 'lookup' }], exclude: [] },
          { module: 'files', subs: [{ name: 'lookup' }], exclude: [] },
          {
            module: 'bulk transactions',
            subs: [{ name: 'lookup' }],
            exclude: [],
          },
        ],
      },
      {
        name: 'report_user',
        setup: [{ module: 'reports', subs: [{ name: '*' }], exclude: [] }],
      },
    ],
  },
  {
    client: 'subway',
    userTypes: [
      {
        name: 'super_user',
        setup: [{ module: '*', subs: [{ name: '*' }], exclude: [] }],
      },
      {
        name: 'display_user',
        setup: [
          {
            module: 'member',
            subs: [{ name: 'lookup' }, { name: 'dashboard' }],
            exclude: [],
          },
          { module: 'subsquad', subs: [{ name: 'lookup' }], exclude: [] },
          { module: 'merchant', subs: [{ name: 'lookup' }], exclude: [] },
        ],
      },
      {
        name: 'report_user',
        setup: [],
      },
    ],
  },
  {
    client: 'farmers',
    userTypes: [
      {
        name: 'display_user',
        setup: [
          {
            module: 'member',
            subs: [
              {
                name: 'lookup',
                subs: [
                  { name: '*' },
                  { name: 'create member' },
                  { name: 'create drd member' },
                ],
              },
              { name: 'dashboard' },
              {
                name: 'transaction',
                subs: [
                  { name: '*' },
                  { name: 'download transaction' }
                ],
              },
              {
                name: 'communication main nz',
                subs: [
                  { name: '*' },
                  { name: 'view email' },
                  { name: 'resend email' },
                  { name: 'edit email' },
                ],
              },
              {
                name: 'notes',
                subs: [
                  { name: '*' },
                  { name: 'view note' },
                  { name: 'update note' }
                ],
              },
              { name: 'notes create' },
              {
                name: 'membership',
                subs: [
                  { name: '*' },
                  { name: 'add membership' },
                  { name: 'end membership' },
                ],
              },
              {
                name: 'identification generic',
                subs: [
                  { name: '*' },
                  { name: 'update identifier status' }
                ],
              },
              { name: 'history' },
              { name: 'icash topup' },
              { name: 'icash topup reversal' },
              { name: 'icash redemption' },
              { name: 'icash redemption reversal' },
              { name: 'icash donation' },
              { name: 'icash donation refund' },
              { name: 'credit allocation' },
              { name: 'credit allocation refund' },
              { name: 'send email for password reset' },
              { name: 'save to pdf' },
              { name: 'update status' },
              { name: 'update member details generic' },
            ],
            exclude: [],
          },
          {
            module: 'merchant',
            subs: [
              { name: 'lookup', subs: [{ name: '*' }, { name: 'create merchant' }] },
              {
                name: 'transaction',
                subs: [{ name: '*' }, { name: 'download transaction' }],
              },
              {
                name: 'identification',
                subs: [{ name: '*' }, { name: 'update identifier status' }],
              },
              { name: 'identification create' },
              {
                name: 'device',
                subs: [{ name: '*' }, { name: 'update merchant device' }],
              },
              { name: 'device create' },
              { name: 'memberships' },
              { name: 'membership create' },
              {
                name: 'bank accounts',
                subs: [{ name: '*' }, { name: 'update bank account' }],
              },
              { name: 'bank accounts create' },
              { name: 'histories' },
              { name: 'update merchant profile' },
              { name: 'update merchant status' },
            ],
            exclude: []
          },
          {
            module: 'reports',
            subs: [
              { name: '*' },
              { name: 'lookup' },
              { name: 'report 2', subs: [{ name: '*' }, { name: 'download report' }] },
              { name: 'report 13', subs: [{ name: '*' }, { name: 'download report' }] },
              {
                name: 'voucher redemption count report',
                subs: [{ name: '*' }, { name: 'download report' }],
              },
              { name: 'report 19', subs: [{ name: '*' }, { name: 'download report' }] },
            ],
            exclude: []
          },
          {
            module: 'files',
            subs: [
              { name: '*' },
              { name: 'files download' }
            ], exclude: []
          },
          {
            module: 'bulk transactions',
            subs: [
              { name: '*' },
              { name: 'lookup' },
              { name: 'create bulk transactions' },
            ],
            exclude: [],
          },
        ],
      },
      {
        name: 'display_user',
        setup: [
          {
            module: 'member',
            subs: [
              {
                name: 'lookup',
                subs: [],
              },
              { name: 'dashboard' },
              {
                name: 'transaction',
                subs: [],
              },
              {
                name: 'communication main nz',
                subs: [
                  { name: 'view email' },
                ],
              },
              {
                name: 'notes',
                subs: [
                  { name: 'view note' },
                ],
              },
              {
                name: 'identification generic',
                subs: [],
              },
              { name: 'history' },
            ],
            exclude: [],
          },
          {
            module: 'merchant',
            subs: [
              { name: 'lookup', subs: [] },
              {
                name: 'transaction',
                subs: [],
              },
              {
                name: 'identification',
                subs: [],
              },
              {
                name: 'device',
                subs: [],
              },
              { name: 'memberships' },
              {
                name: 'bank accounts',
                subs: [],
              },
              { name: 'histories' },
            ],
            exclude: []
          },
        ],
      },
      {
        name: 'report_user',
        setup: [
          {
            module: 'member',
            subs: [
              {
                name: 'lookup',
                subs: [
                  { name: '*' },
                  { name: 'create member' },
                  { name: 'create drd member' },
                ],
              },
              { name: 'dashboard' },
              {
                name: 'transaction',
                subs: [],
              },
              {
                name: 'communication main nz',
                subs: [
                  { name: '*' },
                  { name: 'view email' },
                  { name: 'resend email' },
                  { name: 'edit email' },
                ],
              },
              {
                name: 'notes',
                subs: [
                  { name: '*' },
                  { name: 'view note' },
                  { name: 'update note' }
                ],
              },
              { name: 'notes create' },
              {
                name: 'membership',
                subs: [
                  { name: '*' },
                  { name: 'add membership' },
                  { name: 'end membership' },
                ],
              },
              {
                name: 'identification generic',
                subs: [
                  { name: '*' },
                  { name: 'update identifier status' }
                ],
              },
              { name: 'history' },
              { name: 'send email for password reset' },
              { name: 'save to pdf' },
              { name: 'update status' },
              { name: 'update member details generic' },
            ],
            exclude: [],
          },
          {
            module: 'merchant',
            subs: [
              { name: 'lookup', subs: [] },
              {
                name: 'transaction',
                subs: [],
              },
              {
                name: 'identification',
                subs: [{ name: '*' }, { name: 'update identifier status' }],
              },
              { name: 'identification create' },
              {
                name: 'device',
                subs: [{ name: '*' }, { name: 'update merchant device' }],
              },
              { name: 'device create' },
              { name: 'memberships' },
              { name: 'membership create' },
              {
                name: 'bank accounts',
                subs: [{ name: '*' }, { name: 'update bank account' }],
              },
              { name: 'bank accounts create' },
              { name: 'histories' },
              { name: 'update merchant profile' },
              { name: 'update merchant status' },
            ],
            exclude: []
          },
          {
            module: 'bulk transactions',
            subs: [
              { name: '*' },
              { name: 'lookup' },
              { name: 'create bulk transactions' },
            ],
            exclude: [],
          },
        ],
      },
    ],
  },
]
